<div nz-row class="login-box" nzType="flex" nzJustify="center">
  <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
    <h1>{{ "app.label.welcome" | translate }}</h1>
    <div class="text">{{ "app.login.title" | translate }}</div>
    <form
      nz-form
      [formGroup]="validateForm"
      nzLayout="vertical"
    >
      <nz-form-item>
        <nz-form-label>{{ "app.label.username" | translate }}</nz-form-label>
        <nz-form-control
          [nzErrorTip]="'app.login.username.required' | translate"
        >
          <nz-input-group [nzPrefix]="prefixUser">
            <input
              type="text"
              nz-input
              formControlName="userName"
              placeholder="{{ 'app.label.username' | translate }}"
              [nzSize]="'large'"
              autocomplete="off"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>{{ "app.label.password" | translate }}</nz-form-label>
        <nz-form-control
          [nzErrorTip]="'app.login.password.required' | translate"
        >
          <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixTemplate">
            <input
              [nzSize]="'large'"
              [type]="passwordVisible ? 'text' : 'password'"
              nz-input
              placeholder="{{ 'app.label.password' | translate }}"
              formControlName="password"
              autocomplete="off"
            />
          </nz-input-group>
          <ng-template #suffixTemplate>
            <i
              nz-icon
              [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
              (click)="passwordVisible = !passwordVisible"
            ></i>
          </ng-template>
        </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
            <img [src]="captchaImageUrl" />
          </nz-input-group>
          <ng-template #suffixIconButton>
            <i class="capchaHeight" nz-icon nzType="reload-captcha" nzTheme="outline" (click)="getCaptchaImageAndKey()"></i>
          </ng-template>
          </nz-form-item>
          <nz-form-item>
          <nz-form-label>{{ "app.label.captcha" | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.captcha.required' | translate">
              <input type="text" nz-input formControlName="captcha"
                placeholder="{{ 'app.label.captcha' | translate }}"
                autocomplete="off" />
          </nz-form-control>
        <a
          id="forgotpassword"
          class="text-right display-block w100"
          (click)="forgotpassword()"
          >{{ "app.login.forgotpassword" | translate }}</a>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button
            nz-button
            [nzSize]="'small'"
            [nzType]="'primary'"
            class="btn-signin"
            (click)="goto()"
           [nzLoading]="loading" [disabled]="this.validateForm.invalid"
          >
            {{ "app.label.signin" | translate }}
          </button>
          <button
            nz-button
            [nzSize]="'small'"
            [nzType]="'default'"
            class="btn-signup"
            (click)="signup()"
          >
            {{ "app.label.signup" | translate }}
          </button>
          <!-- <a class="float-right display-block" (click)="signup()"></a> -->
        </nz-form-control>
      </nz-form-item>
    </form>
    <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
    <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
  </nz-card>
</div>
